<template>
	<div id="app">
		<HNB  single-title="App下载"></HNB>
		<div id="Dowmload">
			
			<div class="main">
			<div class="left">
				<div class="box1">
					<div class="svg"><SvgIcon svg-name="lfSign" size="55"></SvgIcon></div>
					<div class="span"><strong>乐范健康APP</strong></div>
				</div>
				<div class="box2">让按摩变得简单</div>
				<div class="box3">
					<ul>
						
						
						<li @click="open">Android</li>
						<li @click="openios">Ios</li>
						<li>扫码下载</li>
					</ul>
					
				</div>
				<div class="img" ><img style="width: 10.1875rem;height: 10.1875rem;" :src="img1" ></div>
			</div>
			<div class="right">
				<img style="width: 19.25rem;height: 30.625rem;" :src="img2" />
			</div>
		    </div>
		</div>
		<BS :BsTitle="bsTitle"></BS>
		
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	export default {
		name: "app",
		
		components: {
			HNB,
			SvgIcon,
			BS
		},
		data(){
			return{
				bsTitle:['服务支持','APP下载'],
				img1:this.GLOBAL.imgHost + '/images/public.png',
				img2:this.GLOBAL.imgHost + '/images/iPhone-XS-Max-Portrait-Space-Gray.png'
			}
		},
		methods:{
			open(){
				window.open('http://sj.qq.com/myapp/detail.htm?apkName=com.easepal.magicpaster')
			},
			openios(){
				window.open('https://itunes.apple.com/cn/app/le-fan-mo-li-tie/id909537333?mt=8')
			}
		}
	}
</script>

<style>
	#Dowmload{
		max-width: 100%;
		height:42.875rem;
		background:rgba(250,250,250,1);
		
		
	}
	#Dowmload .main{
		max-width: 64rem;
		margin: 0 auto;
		position: relative;
		top: 30%;
	}
	#Dowmload .left{
		width: 15.5rem;
		height: 20.75rem;
		float: left;
		/* position: relative;
		top: 35%;
		left: 35%; */
	}
	#Dowmload .left .box1{
		width:20.3125rem;
		height:5rem;
		font-size:2.3rem;
		font-family:Alibaba PuHuiTi-M;
		font-weight:500;
		color:rgba(24,24,24,1);
		line-height:1.25rem;
		cursor: pointer;
	}
	#Dowmload .left .box1 .svg{
		float: left;
		background:rgba(250,250,250,1);
	}
	#Dowmload .left .box1 .span{
		float: left;
		    position: relative;
		    left: -10%;
		    top: 21%;
		
	}
	#Dowmload .left .box2{
		width:10.875rem;
		height:3.8rem;
		font-size:1.5rem;
		font-family:Alibaba PuHuiTi-M;
		font-weight:400;
		color:rgba(24,24,24,1);
		line-height:0.6875rem;
		    position: relative;
		    left: 8%;
			cursor: pointer;
	}
	#Dowmload .left .box3{
		width:6.8125rem;
		height:7.0625rem;
		font-size:1.2rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(0,199,133,1);
		line-height:1.0625rem;
		   cursor: pointer;
		   position: relative;
		       left: 4%;
		   
	}
	#Dowmload .left .box3 ul{
		margin: 0;
		padding-left: 11px;
	}
	#Dowmload .left .box3 ul li{
		list-style: none;
		width: 5.125rem;
		text-align: left;
		padding: 4px;
	}
	#Dowmload .left .img{
		width: 10.1875rem;
		height: 10.1875rem;
		cursor: pointer;
		position: relative;
		    left: 8%;
		
		 
	}
	#Dowmload .right{
		width: 20.25rem;
		height: 30.625rem;
		float: left;
		position: relative;
		top: 30%;
		left: 37%;
		cursor: pointer;
		
	}
</style>
